import React from 'react';
import { Handshake } from 'lucide-react';
import i18n from '../../../../../i18n';
import '../../../../../styles/components/auction-card-real-estate.scss';
import { AuctionIcon, BuildingIcon } from '../../../../common/icons';
import { OnlineAuction } from '../../../components/AuctionsCategory/OnlineAuction';
import { RealEstate } from '../../../components/AuctionsCategory/RealEstate';
import { DirectSale } from '../../../components/AuctionsCategory/DirectSale';

const VALID_TYPES = ['auctions', 'direct_sale', 'real_estate'];
const DEFAULT_TYPE = 'auctions';

class AuctionSwitcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeType: this.getTypeFromURL(),
      fadeIn: true,
      isMobile: window.innerWidth <= 768,
      dropdownOpen: false,
    };
  }

  componentDidMount() {
    window.addEventListener('popstate', this.handlePopState);
    window.addEventListener('resize', this.handleResize);
    // Set default query if none exists
    const params = new URLSearchParams(window.location.search);
    if (!params.get('type')) {
      const url = new URL(window.location);
      url.searchParams.set('type', DEFAULT_TYPE);
      window.history.replaceState({}, '', url);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
    window.removeEventListener('resize', this.handleResize);
  }

  handlePopState = () => {
    this.setState({ activeType: this.getTypeFromURL() });
  };
  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  getTypeConfig = (type) => {
    const types = {
      real_estate: { label: i18n.t('real_estate_auctions') || 'Real Estate Auctions', icon: <BuildingIcon width={22} height={22} /> },
      auctions: { label: i18n.t('online_auctions') || 'Auctions', icon: <AuctionIcon width={22} height={22} /> },
      direct_sale: { label: i18n.t('direct_sale') || 'Direct Sale', icon: <Handshake width={22} height={22} /> },
    };
    return types[type] || types['auctions'];
  };

  getTypeFromURL() {
    const params = new URLSearchParams(window.location.search);
    const type = params.get('type');
    return VALID_TYPES.includes(type) ? type : DEFAULT_TYPE;
  }

  switchType(type) {
    if (type === this.state.activeType) return;
    this.setState({ fadeIn: false });
    setTimeout(() => {
      // Set new type, clear stale filter params
      const url = new URL(window.location);
      url.searchParams.set('type', type);
      url.searchParams.delete('timeFilter');
      url.searchParams.delete('category');
      url.searchParams.delete('sort');
      window.history.pushState({}, '', url);

      this.setState({ activeType: type, fadeIn: true });
    }, 180);
  }

  render() {
    const { activeType, fadeIn } = this.state;

    return (
      <section className="as-section">
        <div className="container-fluid">

          {/* ── Type Switcher ── */}
          {/* ── Type Switcher ── */}
          {!this.state.isMobile ? (
            /* Desktop: buttons */
            <div className="as-type-switcher">
              <button
                className={`as-type-btn ${activeType === 'real_estate' ? 'as-type-btn--active' : 'as-type-btn--inactive'}`}
                onClick={() => this.switchType('real_estate')}
              >
                <BuildingIcon width={26} height={26} />
                {i18n.t('real_estate_auctions') || 'Real Estate Auctions'}
              </button>
              <button
                className={`as-type-btn ${activeType === 'auctions' ? 'as-type-btn--active' : 'as-type-btn--inactive'}`}
                onClick={() => this.switchType('auctions')}
              >
                <AuctionIcon width={26} height={26} />
                {i18n.t('online_auctions') || 'Auctions'}
              </button>
              <button
                className={`as-type-btn ${activeType === 'direct_sale' ? 'as-type-btn--active' : 'as-type-btn--inactive'}`}
                onClick={() => this.switchType('direct_sale')}
              >
                <Handshake width={26} height={26} />
                {i18n.t('direct_sale') || 'Direct Sale'}
              </button>
            </div>
          ) : (
            /* Mobile: dropdown */
            <div className="as-type-dropdown">
              <button
                className="as-type-dropdown__trigger"
                onClick={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}
              >
                <span className="as-type-dropdown__active">
                  {this.getTypeConfig(activeType).icon}
                  {this.getTypeConfig(activeType).label}
                </span>
                <svg
                  className={`as-type-dropdown__chevron ${this.state.dropdownOpen ? 'as-type-dropdown__chevron--open' : ''}`}
                  width="16" height="16" viewBox="0 0 20 20" fill="none"
                >
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              {this.state.dropdownOpen && (
                <div className="as-type-dropdown__menu">
                  {['real_estate', 'auctions', 'direct_sale'].map((type) => {
                    const config = this.getTypeConfig(type);
                    return (
                      <button
                        key={type}
                        className={`as-type-dropdown__option ${activeType === type ? 'as-type-dropdown__option--active' : ''}`}
                        onClick={() => {
                          this.switchType(type);
                          this.setState({ dropdownOpen: false });
                        }}
                      >
                        {config.icon}
                        <span>{config.label}</span>
                        {activeType === type && <span className="as-type-dropdown__check">✓</span>}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* ── Content ── */}
          <div className={`as-content-area ${fadeIn ? 'as-fade-visible' : 'as-fade-enter'}`}>
            {activeType === 'auctions' && <OnlineAuction type="auctions"  onTimeFilterChange={this.props.onTimeFilterChange} counts={this.props.counts}/>}
            {activeType === 'direct_sale' && <DirectSale type="direct_sale"  onTimeFilterChange={this.props.onTimeFilterChange}/>}
            {activeType === 'real_estate' && <RealEstate type="real_estate"  onTimeFilterChange={this.props.onTimeFilterChange}/>}
          </div>

        </div>
      </section>
    );
  }
}
export default AuctionSwitcher;
